import {Injectable} from "@angular/core";

@Injectable()
export class ContractTypesEnum {
    contractTypes = [
        { code: 1, name: 'Contrato de Volume (EA / EAS / SCE / MPSA)' },
        { code: 2, name: 'Managed Services' },
        { code: 3, name: 'CSP' },
        { code: 4, name: 'SPLA' },
        { code: 5, name: 'Open' },
        { code: 6, name: 'Projeto / Consultoria' }
    ];
}

type Contracts = {
    code: number;
    name: string;
}

export interface ContractTypes {
    group: string;
    companyContractType: string;
    items: Contracts[]
}

export class NewContractTypesEnum {
    contractTypes = [
        {
            group: 'Contrato de licença Microsoft',
            companyContractType:"companyContractCSP",
            items: [
                { code: 101, name: 'CSP'}
            ]
        },
        {
            group: 'Managed Services',
            companyContractType: "companyContractManagedServices",
            items: [
                { code: 201, name: 'Managed Services de FCnuvem'},
            ]
        },
        {
            group: 'Contratos de volume 12 Meses',
            companyContractType: "companyContractVolume12Meses",
            items: [
                { code: 301, name: 'MPSA'}
            ]
        },
        {
            group: 'Contratos de volume 36 Meses',
            companyContractType:"companyContractVolume36Meses",
            items: [
                { code: 401, name: 'EA'},
                { code: 402, name: 'SCE'},
                { code: 403, name: 'MPSA'},
            ]
        },
        {
            group: "Outros",
            companyContractType: "companyContractOutros",
            items: []
        }
    ] as ContractTypes[]
}



// WEBPACK FOOTER //
// ./src/app/shared/enums/ContractType.enum.ts